define('GameDayCore/GDModel/ValueObjects/ValueObjectFactory',['require','exports','module'],function(require,exports,module) {

	/**
	 * Base for creating Value Objects. 
	 */
	function VO() {}
 
	VO.ensureVO = function(o, voi) {
		if(!(o instanceof voi)){
			return Object.create(voi.prototype);
		}
		return o;
	};	

	/**
	 * Create Value Object with ability to add properties to its prototype 
	 * while maintaining inheritance.
	 * 
	 * @param  {Object} myvo  Value Object that's being created
	 * @param  {Object} mixin Any prototype level methods/members that should 
	 *                        also be added
	 * @return {Object}       Your Value Object, with proper prototype set
	 */
	VO.create = function(myvo, myproto) {
		var key,
			proto = myvo.prototype = Object.create(VO.prototype);
		for (key in myproto) {
			if(myproto.hasOwnProperty(key)) {
				proto[key] = myproto[key];
			}
		}
		return myvo;
	};

	VO.prototype = {
		updateVO : function() {
			this.constructor.apply(this, arguments);
		}
	};
 
	return VO;
});
